import { displayTextLabelValidator, nonEmptyStringValidator } from '@vista/omnichannel-components-domain';
import { Validator } from '@vista-digital/validator';
export const defaultShowtimeSummaryDisplayText = {
    siteNameLabel: 'Cinema',
    screenNameLabel: 'Screen',
    startsAtLabel: 'Showtime',
    runtimeLabel: 'Runtime',
    selectedSeatsLabel: 'Seats',
    startsAtFormat: '${startsAt|d|MMM DD, HH:mm}',
    attributeLegendLabel: 'Showtime attributes',
    attributeLegendViewButtonLabel: 'What do these mean?',
    attributeLegendModalHelpText: undefined
};
export const showtimeSummaryDisplayTextValidator = Validator.object({
    siteNameLabel: nonEmptyStringValidator,
    screenNameLabel: nonEmptyStringValidator,
    startsAtLabel: nonEmptyStringValidator,
    runtimeLabel: nonEmptyStringValidator,
    selectedSeatsLabel: nonEmptyStringValidator,
    startsAtFormat: nonEmptyStringValidator,
    attributeLegendLabel: nonEmptyStringValidator,
    attributeLegendViewButtonLabel: nonEmptyStringValidator,
    attributeLegendModalHelpText: Validator.optional(displayTextLabelValidator)
});
